document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.brand-list__link_letter');
  
  // Function to handle click on brand links
  links.forEach(link => {
    link.addEventListener('click', function(event) {
      const letter = link.getAttribute('data-list_letter');
      const title = document.querySelector(`[data-letter="${letter}"]`);
      if (title) {
        title.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
    function normalizeText(str) {
      return str
        .toLowerCase()
        .normalize("NFD")                   // Break accented letters into base + accents
        .replace(/[\u0300-\u036f]/g, '')   // Remove accents
        .replace(/[^a-z0-9]/gi, '');       // Remove special characters (optional: keep space if needed)
    }

  // Function to handle input in search box
  const searchInput = document.querySelector('.brand-list__search');
  const brandTitles = document.querySelectorAll('.brand-list__brand-title');

  searchInput.addEventListener('input', function() {
    // const searchTerm = this.value.trim().toLowerCase();
    const searchTerm = normalizeText(this.value.trim());
    
    brandTitles.forEach(title => {
        // const brandName = title.textContent.trim().toLowerCase();
      const brandName = normalizeText(title.textContent.trim());
      const parentBrand = title.closest('.brand-list__brand');
      
        if (brandName.includes(searchTerm)) {
            parentBrand.style.display = 'block';
        } else {
            parentBrand.style.display = 'none';
        }

        // Check if all child elements are hidden and hide parent if necessary
        const parentGroup = parentBrand.closest('.brand-list__group');
        const brandItems = parentGroup.querySelectorAll('.brand-list__brand');
        const allHidden = Array.from(brandItems).every(item => item.style.display === 'none');
        parentGroup.style.display = allHidden ? 'none' : '';
        // if (allHidden) {
        //     parentGroup.style.display = 'none';
        // } else {
        //     parentGroup.style.display = ''; // Reset to default display value
        // }
    });
    // const parentGroup = document.querySelectorAll('.brand-list__group');
    const allGroups = document.querySelectorAll('.brand-list__group');
    const noResult = Array.from(allGroups).every(item => item.style.display === 'none');
    if (noResult) {
      document.getElementById("no_result_found").style.display = 'block';
    } else {
      document.getElementById("no_result_found").style.display = 'none';
    }

});

});
